import type en from "../en/marketing";
import type { Messages } from "../../types";

const ar: Messages<typeof en> = {
  stateDisabled: "معطّل",
  stateExpired: "منتهي الصلاحية",
  stateUsedUp: "مُستنفَد",
  stateScheduled: "مجدول",
  stateActive: "نشط",

  discountsTitle: "الخصومات",
  discountsDescription: "رموز يُدخلها العملاء عند الدفع. رمز واحد لكل طلب — لا يمكن الجمع بين الرموز.",
  createDiscount: "إنشاء خصم",
  notInPlan: "رموز الخصم غير مشمولة في باقتك الحالية. قم بالترقية لإنشائها.",
  discountDeleted: "تم حذف الخصم.",
  noDiscounts: "لا توجد رموز خصم بعد",
  noDiscountsHint: "أنشئ رمزًا مثل WELCOME10 لمكافأة المشتركين في النشرة البريدية أو لإطلاق تخفيضات.",
  colCode: "الرمز",
  colValue: "القيمة",
  colUsed: "مرات الاستخدام",
  colWindow: "فترة الصلاحية",
  percentOff: "خصم {value}%",
  amountOff: "خصم {amount}",
  freeShipping: "شحن مجاني",
  entireOrder: "الطلب بأكمله",
  productsCount: "{count} منتج",
  productsCount_zero: "لا منتجات",
  productsCount_one: "منتج واحد",
  productsCount_two: "منتجان",
  productsCount_few: "{count} منتجات",
  productsCount_many: "{count} منتجًا",
  collectionsCount: "{count} مجموعة",
  collectionsCount_zero: "لا مجموعات",
  collectionsCount_one: "مجموعة واحدة",
  collectionsCount_two: "مجموعتان",
  collectionsCount_few: "{count} مجموعات",
  collectionsCount_many: "{count} مجموعة",
  minSubtotalShort: "الحد الأدنى {amount}",
  perCustomer: "{count} لكل عميل",
  now: "الآن",
  noEnd: "بلا نهاية",

  editDiscount: "تعديل الخصم",
  newBreadcrumb: "جديد",
  usedTimes: "استُخدم {count} مرة",
  usedTimes_zero: "لم يُستخدم بعد",
  usedTimes_one: "استُخدم مرة واحدة",
  usedTimes_two: "استُخدم مرتين",
  usedTimes_few: "استُخدم {count} مرات",
  usedTimes_many: "استُخدم {count} مرة",
  deleteTitle: "حذف {code}؟",
  deleteUsedBody: "استُخدم هذا الرمز في طلبات، لذا سيُعطَّل بدلًا من حذفه للحفاظ على دقة سجل الطلبات.",
  deleteBody: "سيُحذف الرمز نهائيًا ولن يتمكن العملاء من استخدامه بعد الآن.",
  discountCreated: "تم إنشاء الخصم. شارك الرمز {code} مع عملائك.",

  percentRange: "أدخل نسبة مئوية بين 0.01 و100.",
  percentRangeField: "أدخل نسبة مئوية بين 0.01 و100",
  enterDiscountAmount: "أدخل مبلغ الخصم.",
  enterAmount: "أدخل مبلغًا",
  invalidStart: "أدخل تاريخ بدء صالحًا.",
  invalidEnd: "أدخل تاريخ انتهاء صالحًا.",
  invalidDate: "تاريخ غير صالح",
  discountSaved: "تم حفظ الخصم.",
  deactivatedInstead: "استُخدم هذا الرمز في طلبات من قبل، لذا عُطّل بدلًا من حذفه (يُحتفظ به لسجل الطلبات والتقارير).",

  codeDescription: "يُدخله العملاء عند الدفع. يمكن استخدام رمز خصم واحد فقط لكل طلب — لا يمكن الجمع بين الرموز.",
  discountCode: "رمز الخصم",
  codeHint: "من 3 إلى 32 حرفًا أو رقمًا أو - أو _. لا يميّز بين الأحرف الكبيرة والصغيرة.",
  generate: "توليد",
  internalTitle: "عنوان داخلي",
  internalTitleHint: "تراه أنت فقط، مثلًا «ترحيب النشرة البريدية».",
  discountType: "نوع الخصم",
  kindPercentage: "نسبة مئوية",
  kindPercentageHint: "مثلًا خصم 10%",
  kindFixed: "مبلغ ثابت",
  kindFixedHint: "مثلًا خصم 5.00 {currency}",
  kindFreeShippingHint: "يلغي تكلفة الشحن",
  percentageOff: "نسبة الخصم",
  amountOffLabel: "مبلغ الخصم",
  amountOffHint: "يُخصم من المنتجات المؤهلة، ولا يتجاوز إجماليها أبدًا.",
  appliesTo: "ينطبق على",
  specificProducts: "منتجات محددة",
  specificCollections: "مجموعات محددة",
  pickProductsEmpty: "ابحث في الأعلى لاختيار المنتجات.",
  noCollections: "ليست لديك أي مجموعات بعد.",
  freeShippingEligible: "يُطبَّق الشحن المجاني عندما تحتوي السلة على منتج مؤهل.",
  requirements: "الشروط والحدود",
  minSubtotal: "الحد الأدنى للمجموع الفرعي",
  totalUses: "إجمالي مرات الاستخدام",
  usedSoFar: "استُخدم {count} مرة حتى الآن.",
  usedSoFar_zero: "لم يُستخدم حتى الآن.",
  usedSoFar_one: "استُخدم مرة واحدة حتى الآن.",
  usedSoFar_two: "استُخدم مرتين حتى الآن.",
  usedSoFar_few: "استُخدم {count} مرات حتى الآن.",
  usedSoFar_many: "استُخدم {count} مرة حتى الآن.",
  unlimitedHint: "اتركه فارغًا لعدد غير محدود.",
  usesPerCustomer: "مرات الاستخدام لكل عميل",
  perCustomerHint: "يُحتسب حسب عنوان البريد الإلكتروني.",
  statusSchedule: "الحالة والجدولة",
  timezoneHint: "الأوقات بالمنطقة الزمنية للمتجر ({timezone}).",
  activeHint: "أوقف التفعيل لإيقاف الرمز مؤقتًا دون حذفه.",
  starts: "يبدأ",
  startsHint: "فارغ = فورًا.",
  ends: "ينتهي",
  endsHint: "فارغ = لا ينتهي أبدًا.",

  marketingTitle: "التسويق",
  marketingDescription: "استعِد المتسوقين ونمِّ قائمتك البريدية.",
  abandonedReminders: "تذكيرات السلال المتروكة",
  paidPlans: "الباقات المدفوعة",
  on: "مفعّل",
  off: "متوقف",
  abandonedInfo: "يرسل تذكيرًا واحدًا بالبريد الإلكتروني إلى متسوق ترك منتجات في سلته. لا تُرسَل التذكيرات إلا للمتسوقين الذين وافقوا على التسويق عند الدفع، ومرة واحدة على الأكثر لكل سلة، ويتضمن كل بريد رابطًا لإلغاء الاشتراك.",
  abandonedNotInPlan: "تذكيرات السلال المتروكة غير مشمولة في باقة {plan}. {upgrade} لتفعيلها.",
  upgrade: "قم بالترقية",
  sendAbandoned: "إرسال تذكيرات السلال المتروكة",
  delayLabel: "إرسال التذكير بعد (بالساعات)",
  delayHint: "بين 1 و72 ساعة من عدم نشاط السلة.",
  newsletterSignup: "الاشتراك في النشرة البريدية",
  newsletterLabel: "عرض نموذج اشتراك في النشرة البريدية في متجرك",
  newsletterHint: "يُضاف الزوار المشتركون إلى قائمة مشتركيك مع تاريخ موافقتهم. ترسل الحملات بأداة البريد الإلكتروني الخاصة بك.",
  saveMarketing: "حفظ إعدادات التسويق",
  marketingSaved: "تم حفظ إعدادات التسويق",
  subscribers: "المشتركون",
  activeSubscribers: "{n} مشترك نشط",
  activeSubscribers_zero: "لا مشتركين نشطين",
  activeSubscribers_one: "مشترك نشط واحد",
  activeSubscribers_two: "مشتركان نشطان",
  activeSubscribers_few: "{n} مشتركين نشطين",
  activeSubscribers_many: "{n} مشتركًا نشطًا",
  exportCsv: "تصدير CSV",
  noSubscribers: "لا يوجد مشتركون بعد",
  noSubscribersHint: "سيظهر هنا الأشخاص الذين يشتركون في نشرتك البريدية أو يوافقون على التسويق عند الدفع.",
  colSource: "المصدر",
  colSubscribed: "تاريخ الاشتراك",
  sourceStorefront: "واجهة المتجر",
  sourceCheckout: "صفحة الدفع",
  showing100: "يُعرض أحدث 100 مشترك. صدّر ملف CSV للحصول على القائمة الكاملة.",
  abandonedLast30: "السلال المتروكة · آخر 30 يومًا",
  abandoned: "متروكة",
  abandonedDef: "سلال تحتوي على منتجات، غير نشطة لأكثر من ساعة ولم يُكمَل الدفع فيها.",
  withEmail: "مع بريد إلكتروني",
  withEmailDef: "سلال متروكة أدخل فيها المتسوق عنوان بريد إلكتروني.",
  reminded: "تم تذكيرها",
  remindedDef: "سلال تلقّت بريد تذكير.",
  recovered: "مستعادة",
  recoveredDef: "سلال تم تذكيرها ثم تحوّلت لاحقًا إلى طلب.",
  moreWays: "طرق أخرى للنمو",
  discountsHint: "رموز وعروض تلقائية",
  seo: "تحسين محركات البحث وإعادة التوجيه",
  seoHint: "خريطة الموقع وإعادة توجيه الروابط",
  analytics: "التحليلات",
  analyticsHint: "المبيعات ومسار التحويل وأفضل المنتجات",

  analyticsDescription: "أداء المبيعات بعملة {currency}. تُستبعد طلبات وضع الاختبار دائمًا.",
  rangeToday: "اليوم",
  range7d: "7 أيام",
  range30d: "30 يومًا",
  range90d: "90 يومًا",
  range12m: "12 شهرًا",
  keyFigures: "الأرقام الرئيسية",
  netSales: "صافي المبيعات",
  grossSales: "إجمالي المبيعات",
  discounts: "الخصومات",
  discountsDef: "إجمالي الخصومات على الطلبات المدفوعة في هذه الفترة (بما فيها خصومات الشحن المجاني).",
  refunds: "المبالغ المستردة",
  paidOrders: "الطلبات المدفوعة",
  aov: "متوسط قيمة الطلب",
  totalCollected: "إجمالي المحصّل",
  afterRefunds: "{amount} بعد الاستردادات",
  pendingPayment: "مدفوعات معلّقة",
  pendingSub: "{count} طلب · لم يُستلم",
  pendingSub_zero: "لا طلبات · لم يُستلم",
  pendingSub_one: "طلب واحد · لم يُستلم",
  pendingSub_two: "طلبان · لم يُستلما",
  pendingSub_few: "{count} طلبات · لم تُستلم",
  pendingSub_many: "{count} طلبًا · لم يُستلم",
  shippingCharged: "رسوم الشحن المحصّلة",
  shippingDef: "رسوم الشحن المفروضة على الطلبات المدفوعة.",
  taxCharged: "الضرائب المحصّلة",
  taxDef: "الضرائب على الطلبات المدفوعة (سواء كانت مشمولة في الأسعار أو مضافة عند الدفع). أنت مسؤول عن توريدها.",
  customers: "العملاء",
  repeatCustomers: "العملاء المتكررون",
  repeatSub: "{repeat} من {total} (منذ البداية)",
  defPaidOrders: "الطلبات ذات الدفع المؤكد (مدفوعة أو مستردة جزئيًا أو مستردة أو متنازع عليها) المقدَّمة في هذه الفترة. تُستبعد طلبات وضع الاختبار.",
  defGross: "مجموع المجاميع الفرعية للمنتجات قبل الخصومات، للطلبات ذات الدفع المؤكد. لا يشمل الشحن ومبالغ الضريبة وحدها. تُستبعد طلبات وضع الاختبار.",
  defNet: "صافي المبيعات = إجمالي المبيعات − الخصومات − المبالغ المستردة في هذه الفترة. تُستبعد طلبات وضع الاختبار.",
  defAov: "متوسط قيمة الطلب = (إجمالي المبيعات − الخصومات) ÷ الطلبات المدفوعة.",
  defPending: "إجمالي الطلبات المفتوحة التي لا تزال تنتظر الدفع (مثل التحويل البنكي، والدفع عند الاستلام، والمدفوعات الإلكترونية غير المكتملة). هذه الأموال لم تُستلم بعد.",
  defRefunds: "عمليات الاسترداد التي نجحت في هذه الفترة، بغض النظر عن تاريخ تقديم الطلب.",
  defCollected: "المبالغ التي حصّلها مزوّدو الدفع لديك أو التي ميّزتها كمستلَمة للمدفوعات خارج الإنترنت، قبل الاستردادات. لا تشمل رسوم المزوّد لأنه هو من يفرضها.",
  defCustomers: "عناوين البريد الإلكتروني المميزة للعملاء الذين لديهم طلب مدفوع في هذه الفترة.",
  defRepeat: "العملاء (منذ البداية) الذين لديهم أكثر من طلب مدفوع، من بين جميع العملاء الذين لديهم طلب مدفوع.",
  howCalculated: "كيف تُحتسب هذه الأرقام",
  averageOrderValue: "متوسط قيمة الطلب",
  grossMargin: "هامش الربح الإجمالي",
  grossMarginDef: "الإيرادات مطروحًا منها التكلفة، فقط للمنتجات التي أدخلت لها سعر تكلفة. يُعرض «—» عندما تكون التكلفة غير معروفة.",
  feesProfit: "الرسوم والأرباح",
  feesProfitDef: "رسوم معالجة المدفوعات يفرضها مزوّدك الخاص ولا تظهر للمنصة، لذا لا يُحتسب الربح بعد الرسوم.",
  salesByDay: "المبيعات حسب اليوم",
  salesByDayHint: "صافية من الخصومات، للطلبات المدفوعة، حسب تاريخ الطلب (أيام بتوقيت UTC).",
  noPaidOrders: "لا توجد طلبات مدفوعة في هذه الفترة.",
  advancedAnalytics: "التحليلات المتقدمة",
  advancedHint: "أفضل المنتجات مع الهوامش، وتوزيع حالات الدفع، ومسار التحويل، وإحصاءات السلال المتروكة متاحة في باقتَي Growth وScale.",
  seePlans: "عرض الباقات",
  askOwner: "اسأل مالك المتجر عن الترقية.",
  topProducts: "أفضل المنتجات",
  topProductsHint: "حسب الإيرادات (صافية من خصومات المنتجات) على الطلبات المدفوعة.",
  noSales: "لا توجد مبيعات في هذه الفترة",
  colProduct: "المنتج",
  colUnits: "الوحدات",
  colRevenue: "الإيرادات",
  noCostPrice: "لم يُدخل سعر التكلفة",
  paymentStatus: "حالة الدفع",
  paymentStatusHint: "كل الطلبات الفعلية المقدَّمة في هذه الفترة.",
  noOrdersPeriod: "لا توجد طلبات في هذه الفترة",
  funnel: "مسار التحويل",
  funnelHint: "الزوار الفريدون في كل خطوة.",
  visitors: "الزوار",
  viewedProduct: "شاهدوا منتجًا",
  addedToCart: "أضافوا إلى السلة",
  startedCheckout: "بدؤوا الدفع",
  placedOrder: "قدّموا طلبًا",
  funnelNote: "لا تُحتسب إلا الزيارات التي سجّلها سكربت التتبّع الخاص بالمتجر. لا يُحتسب الزوار الذين يحظرون السكربتات، لذا قد تكون الزيارات الفعلية أعلى. قد تظهر طلبات الاختبار ضمن «قدّموا طلبًا».",
  abandonedCarts: "السلال المتروكة",
  abandonedCartsDef: "سلال تحتوي على منتجات، غير نشطة لأكثر من ساعة، آخر تحديث لها في هذه الفترة ولم يُكمَل الدفع فيها.",
  withEmailDefShort: "سلال متروكة أدخل فيها المتسوق بريدًا إلكترونيًا.",
  remindersSent: "التذكيرات المرسلة",
  remindersSentDef: "سلال متروكة تلقّت بريد تذكير (للمتسوقين الموافقين فقط).",
  recoveredDefLong: "سلال تم تذكيرها ثم تحوّلت لاحقًا إلى طلب.",
  feesAlert: "رسوم معالجة المدفوعات يفرضها مزوّد الدفع الخاص بك وهي غير مشمولة. راجع لوحة تحكم المزوّد لمعرفة المبالغ المحوّلة إليك.",
};

export default ar;
